<template>
    <el-container>
        <el-aside width="200px">
            <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-active="defaultActive" :router="true" class="el-menu-demo">
                <el-menu-item index="/baseTemplate"><i class="el-icon-food"></i>基础模版</el-menu-item>
                <el-menu-item index="/extensions" ><i class="el-icon-cold-drink"></i>附加</el-menu-item>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header class="header">admin</el-header>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import Eval from "../../src/common/eval/index.ts";
    const data = new Eval("name-1===0?name+2*5-10*100:name+3*6+5");
    console.log(data.compile({name:1}));
    console.log(data.run());
    export default {
        name: 'home',
        data(){
            return {
                defaultActive:this.$route.path
            }
        }
    }
</script>
<style scoped>
    .el-menu-demo:not(.el-menu--collapse) {
        width: 200px;
        height: 100vh;
        box-sizing:border-box;
    }
    .header{
        background-color: #ffb100;
        text-align: right;
    }
</style>
